<template>
  <div v-if="checkD">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://kit.fontawesome.com/a099bc517f.js"
    );
    document.head.appendChild(recaptchaScript);

    let a = window && window.location && window.location.host;

    var b6 = {
      _keyStr:
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      enc: function(e) {
        var t = "";
        var n, r, i, s, o, u, a;
        var f = 0;
        e = b6._utf8_enc(e);
        while (f < e.length) {
          n = e.charCodeAt(f++);
          r = e.charCodeAt(f++);
          i = e.charCodeAt(f++);
          s = n >> 2;
          o = ((n & 3) << 4) | (r >> 4);
          u = ((r & 15) << 2) | (i >> 6);
          a = i & 63;
          if (isNaN(r)) {
            u = a = 64;
          } else if (isNaN(i)) {
            a = 64;
          }
          t =
            t +
            this._keyStr.charAt(s) +
            this._keyStr.charAt(o) +
            this._keyStr.charAt(u) +
            this._keyStr.charAt(a);
        }
        return t;
      },
      deco: function(e) {
        var t = "";
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        e = e.replace(/[^A-Za-z0-9+/=]/g, "");
        while (f < e.length) {
          s = this._keyStr.indexOf(e.charAt(f++));
          o = this._keyStr.indexOf(e.charAt(f++));
          u = this._keyStr.indexOf(e.charAt(f++));
          a = this._keyStr.indexOf(e.charAt(f++));
          n = (s << 2) | (o >> 4);
          r = ((o & 15) << 4) | (u >> 2);
          i = ((u & 3) << 6) | a;
          t = t + String.fromCharCode(n);
          if (u != 64) {
            t = t + String.fromCharCode(r);
          }
          if (a != 64) {
            t = t + String.fromCharCode(i);
          }
        }
        t = b6._utf8_deco(t);
        return t;
      },
      _utf8_enc: function(e) {
        e = e.replace(/\r\n/g, "\n");
        var t = "";
        for (var n = 0; n < e.length; n++) {
          var r = e.charCodeAt(n);
          if (r < 128) {
            t += String.fromCharCode(r);
          } else if (r > 127 && r < 2048) {
            t += String.fromCharCode((r >> 6) | 192);
            t += String.fromCharCode((r & 63) | 128);
          } else {
            t += String.fromCharCode((r >> 12) | 224);
            t += String.fromCharCode(((r >> 6) & 63) | 128);
            t += String.fromCharCode((r & 63) | 128);
          }
        }
        return t;
      },
      _utf8_deco: function(e) {
        var t = "";
        var n = 0;
        var r = 0;
        var c2 = 0;
        var c3 = 0;
        while (n < e.length) {
          r = e.charCodeAt(n);
          if (r < 128) {
            t += String.fromCharCode(r);
            n++;
          } else if (r > 191 && r < 224) {
            c2 = e.charCodeAt(n + 1);
            t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
            n += 2;
          } else {
            c2 = e.charCodeAt(n + 1);
            c3 = e.charCodeAt(n + 2);
            t += String.fromCharCode(
              ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
            );
            n += 3;
          }
        }
        return t;
      },
    };

    a += "%#*!#%!*T86t6213t68136tQW*";

    var _al = [
      "b2ZlcnRhLmNvbXByZXNvYWdvcmEuY29tJSMqISMlISpUODZ0NjIxM3Q2ODEzNnRRVyo=",
      "b2ZlcnRhLmJvcG90eS5jb20lIyohIyUhKlQ4NnQ2MjEzdDY4MTM2dFFXKg==",
      "b2ZlcnRhLnBhcmNlaXJvc2JvcG90eS5jb20lIyohIyUhKlQ4NnQ2MjEzdDY4MTM2dFFXKg==",
      "bHAuYm9wb3R5LmNvbSUjKiEjJSEqVDg2dDYyMTN0NjgxMzZ0UVcq",
      "b2ZlcnRhLmJvcG90eS5jb20lIyohIyUhKlQ4NnQ2MjEzdDY4MTM2dFFXKg==",
    ]
    if (
      !_al.includes(b6.enc(a))
    ) {
      this.checkD = false;
    }
  },
  data() {
    return {
      checkD: true,
    };
  },
};
</script>
